<template>
  <span
    >Welcome to <b>Qsstoragw</b></span>
</template>

<script>
export default {
  name: "notification-template",
};
</script>
